var e={props:{align:{type:String,validator:function(e){return["left","right","center"].includes(e)}},bold:{type:Boolean,default:!1},subtle:{type:Boolean,default:!1}}};export{e as default};
